import { Report } from "pmt-types/src/models/Report.ts";
import { useMutation } from "react-query";
import { useAuthentication } from "../useAuthentication.ts";

export const useMutationAddReport = () => {
  const { accessToken } = useAuthentication();

  return useMutation(
    async (report: Report) => {
      const response = await fetch(`${import.meta.env.VITE_API_HOST}/reports`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          authorization: accessToken ?? "",
        },
        body: JSON.stringify(report),
      });

      if (!response.ok) {
        throw new Error("Failed to upsert report");
      }

      return (await response.json()) as Report;
    },
    {
      onError: (error, data) => {
        console.error("Failed to upsert report", error, data);
      },
    },
  );
};
